import {memo} from 'react';
import machineIcon from '../../../../../../assets/image/inputGroups/machinery.svg';
import {IStoreOrder} from '../../../../../../services/hookService/getStoreListOrder/types';
import {getPersianDateTime} from '../../../../../../utilities/helper/GetPersianDateTime';
import InfoRow from '../../../../../shopping-basket/ItemCard/InfoRow';
import {MyStoreSettlementsTabsType} from '../settlementTabsConfig';
import ProductIcon from './ProductIcon';

interface IProps {
  storeOrder: IStoreOrder;
  parentOrderGuid: string;
  selectedTab: MyStoreSettlementsTabsType;
}

const MyStoreSettlementsItems = memo(({storeOrder, selectedTab}: IProps) => {
  const label = TAB_LABELS[selectedTab];

  return (
    <div className="relative space-y-3 cardItem">
      {/* Product Icons */}
      <div className="grid grid-cols-3 w-[70%] gap-2 py-2 justify-items-start">
        {storeOrder?.order_items.map(item => (
          <ProductIcon
            key={item.guid}
            icon={item.image ?? item.sub_brand_image ?? machineIcon}
            count={item.quantity}
          />
        ))}
      </div>

      {/* Status Label */}
      <div
        className={`absolute px-2.5 py-1 text-xs rounded-2xl top-2 left-5 ${label?.bg} ${label?.color}`}
      >
        {label?.badgeText}
      </div>

      {/* Total Price */}
      <InfoRow
        icon="icon-namemoney"
        label="مبلغ کل سفارش"
        value={
          storeOrder?.total_price
            ? `${storeOrder.total_price.toLocaleString()} تومان`
            : 'نامشخص'
        }
      />

      {/* Tab-specific InfoRows */}
      {TAB_INFO_ROWS[selectedTab](storeOrder)}
    </div>
  );
});

export default MyStoreSettlementsItems;

const TAB_LABELS: Record<
  MyStoreSettlementsTabsType,
  {badgeText: string; bg: string; color: string}
> = {
  received: {
    badgeText: 'درحال تامین سفارش',
    bg: 'bg-zinc-50',
    color: 'text-red-700',
  },
  pending_settlement: {
    badgeText: 'در انتظار پرداخت',
    bg: 'bg-orange-50',
    color: 'text-amber-600',
  },
  completed: {
    badgeText: 'واریز شده',
    bg: 'bg-farm-shop-50',
    color: 'text-farm-shop-600',
  },
};

const TAB_INFO_ROWS: Record<
  MyStoreSettlementsTabsType,
  (order: IStoreOrder) => JSX.Element[]
> = {
  received: order => [
    <InfoRow
      key="created"
      icon="icon-nameCalendar"
      label="تاریخ ثبت سفارش"
      value={getPersianDateTime(order?.created_at) ?? 'نامشخص'}
    />,
    <InfoRow
      key="supply"
      icon="icon-Report-List"
      label="تاریخ تامین سفارش"
      value={getPersianDateTime(order?.supply_date) ?? 'نامشخص'}
    />,
  ],
  pending_settlement: order => [
    <InfoRow
      key="delivery"
      icon="icon-nameCalendar"
      label="تاریخ تحویل سفارش"
      value={getPersianDateTime(order?.delivery_date) ?? 'نامشخص'}
    />,
  ],
  completed: order => [
    <InfoRow
      key="deposit"
      icon="icon-nameCalendar"
      label="تاریخ واریز مبلغ"
      value={getPersianDateTime(order?.store_withdrawal?.date) ?? 'نامشخص'}
    />,
    <InfoRow
      key="tracking"
      icon="icon-Report-List"
      label="شماره پیگیری"
      value={order?.store_withdrawal?.code ?? 'نامشخص'}
    />,
  ],
};
